const featuredPostsCount = 3
const imageUrlToAvoid = 'assets/no_image_new_blog_image.png'

export {
  featuredPostsCount,
  imageUrlToAvoid
}
